export default __webpack_public_path__ + "static/media/QuestBanner.26e849e9.png";